/**
 * @generated SignedSource<<da2765b83857473a0e31bc874491a04c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Status = "ACTIVE" | "ARCHIVED" | "DRAFT" | "INACTIVE" | "TEMPLATE" | "%future added value";
export type processDefinitionQueryStatusMutation$variables = {
  id: string;
  status: Status;
};
export type processDefinitionQueryStatusMutation$data = {
  readonly changeProcessDefinitionStatus: boolean | null | undefined;
};
export type processDefinitionQueryStatusMutation = {
  response: processDefinitionQueryStatusMutation$data;
  variables: processDefinitionQueryStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "ids.0",
            "variableName": "id"
          }
        ],
        "kind": "ListValue",
        "name": "ids"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "kind": "ScalarField",
    "name": "changeProcessDefinitionStatus",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionQueryStatusMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "processDefinitionQueryStatusMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ec89ca01f83f4eddf9dbb5407c0ea70c",
    "id": null,
    "metadata": {},
    "name": "processDefinitionQueryStatusMutation",
    "operationKind": "mutation",
    "text": "mutation processDefinitionQueryStatusMutation(\n  $id: ID!\n  $status: Status!\n) {\n  changeProcessDefinitionStatus(ids: [$id], status: $status)\n}\n"
  }
};
})();

(node as any).hash = "0d77081247f2fb5efbd1efb2d7f86c3d";

export default node;
